module.exports = __webpack_public_path__ + "static/media/bb_logo_icon.3cdaae7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bb_logo_icon.svg
// module id = 65
// module chunks = 0